import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// Components
import DocumentTypeDropdown from '../../dropdowns/DocumentTypeDropdown';
import { Checkbox } from '@gulfwinds/ui-components';
import FieldsToSelectDropdown from './components/FieldsToSelectDropdown';
import { getDocumentTypes as fetchData } from 'src/fetch/documents';
import { getDocumentTypes, setDocumentTypes } from 'src/slices/documentTypes';

const DocumentTypeFilter = ({
  filter, onFilterChange, fieldsNameForSearch, fieldInfo,
}) => {
  const { value } = filter;
  const dispatch = useDispatch();
  const documentTypes = useSelector(getDocumentTypes);
  const [displayValue, setDisplayValue] = useState(!filter.compareWithOtherField ? value : null);
  const [compareWithOtherFieldDisplayValue, setCompareWithOtherFieldDisplayValue] = useState(
    filter.compareWithOtherField ? value : null,
  );
  const [compareWithOtherField, setCompareWithOtherField] = useState(filter.compareWithOtherField);

  const onChange = (event) => {
    const newFilter = {
      ...filter,
      value: event.target.value.id,
      fieldInfo,
    };
    delete newFilter.compareWithOtherField;

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setDisplayValue(event.target.value);
  };

  useEffect(() => {
    setCompareWithOtherField(filter.compareWithOtherField);
  }, [filter.compareWithOtherField]);

  useEffect(() => {
    const setValue = filter.compareWithOtherField ? setCompareWithOtherFieldDisplayValue : setDisplayValue;
    setValue(value);
  }, [value]);

  const handleFieldToCompareChanged = (event) => {
    const value = event.target.value.field;

    const newFilter = {
      ...filter,
      value,
      compareWithOtherField: true,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setCompareWithOtherFieldDisplayValue(event.target.value);
  };

  const handleCompareWithOtherFields = ({ value }) => {
    const newFilter = value ? {
      ...filter,
      value: typeof compareWithOtherFieldDisplayValue === 'object'
        ? compareWithOtherFieldDisplayValue?.field : compareWithOtherFieldDisplayValue,
      compareWithOtherField: true,
      fieldInfo,
    } : {
      field: filter.field,
      operator: filter.operator,
      value: typeof displayValue === 'object' ? displayValue?.value : displayValue,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    const setValue = !value ? setCompareWithOtherFieldDisplayValue : setDisplayValue;
    setValue(null);
    setCompareWithOtherField(value);
  };

  useEffect(() => {
    if (!documentTypes || documentTypes.length === 0) {
      fetchData().then((data) => dispatch(setDocumentTypes({ documentTypes: data })));
    }
  }, []);

  return (
    <div className='app-filters-input'>
      {compareWithOtherField && fieldsNameForSearch.length > 0
        ? (
          <FieldsToSelectDropdown
            fields={fieldsNameForSearch}
            onFieldChanged={handleFieldToCompareChanged}
            value={compareWithOtherFieldDisplayValue}
          />
        ) : <DocumentTypeDropdown onChange={onChange} value={displayValue} clearButton={false} />}
      {fieldsNameForSearch.length > 0 && (
        <div className='filter-cbx-wrapper'>
          <Checkbox
            value={compareWithOtherField}
            label='Compare with other field'
            onChange={handleCompareWithOtherFields}
          />
        </div>
      )}
    </div>
  );
};

export default DocumentTypeFilter;
